import React from 'react';

export default function TCCoin({
  width = '47',
  height = '47',
  color = 'var(--membership-lime)',
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill={color} />
      <path d="M13.6732 6.74915C13.7269 6.74915 13.7798 6.75298 13.8315 6.75989C13.8725 6.76533 13.9127 6.77291 13.9523 6.78242C13.9598 6.78425 13.9674 6.78597 13.9749 6.78794C14.4843 6.92127 14.8602 7.38455 14.8602 7.93563C14.8602 8.59082 14.3289 9.12212 13.6737 9.12212H12.5866C12.0432 9.1252 11.6039 9.56641 11.6039 10.1105C11.6039 10.6564 12.0463 11.0991 12.5922 11.0991H13.6732C14.3283 11.0991 14.8594 11.6302 14.8594 12.2853C14.8594 12.9404 14.3284 13.4717 13.6732 13.4718H12.5922C10.7359 13.4717 9.23094 11.9668 9.23094 10.1105C9.23094 9.76648 9.28279 9.43462 9.3788 9.12212H8.53265V12.285C8.53261 12.9401 8.00133 13.4713 7.34617 13.4713C6.69102 13.4713 6.15972 12.9401 6.15968 12.285V9.12212H5.27713C4.62197 9.12208 4.09094 8.5908 4.09094 7.93563C4.09096 7.28048 4.62198 6.74933 5.27713 6.74929H12.5799C12.584 6.74928 12.5881 6.74915 12.5922 6.74915H13.6732Z" fill="#101010" />
    </svg>
  );
}
